import { render } from "./portalIndex.vue?vue&type=template&id=04c57393&scoped=true"
import script from "./portalIndex.vue?vue&type=script&lang=js"
export * from "./portalIndex.vue?vue&type=script&lang=js"

import "./portalIndex.vue?vue&type=style&index=0&id=04c57393&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c57393"]])

export default __exports__